import { Typography } from 'antd';
import type { BrowseByTopicCardProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { getHelpCenterIcon } from '../../utils';

const BrowseByTopicCard = ({ topic, onSelect }: BrowseByTopicCardProps) => {
  const { name, article_count, icon } = topic;

  return (
    <button
      type='button'
      className={styles.browseByTopicCard}
      onClick={() => onSelect(topic)}
    >
      <span className={styles.browseByTopicIcon}>
        {getHelpCenterIcon('topic', icon)}
      </span>
      <Typography.Text className={styles.browseByTopicName}>
        {name}
      </Typography.Text>
      <span className={styles.browseByTopicCount}>
        {article_count} {article_count === 1 ? 'article' : 'articles'}
      </span>
    </button>
  );
};

export default BrowseByTopicCard;
